import { useCallback, useEffect, useState } from "react";
import { Marker, Pane, Tooltip } from "react-leaflet";
import L, { MarkerCluster, icon } from "leaflet";
import { useAppSelector } from "Hooks/useRedux";
import useSurveys from "Hooks/useSurveys";
import MarkerClusterGroup from "react-leaflet-cluster";
import SourceSvg from "Assets/Images/Survey/source-icon.svg";
import destinationSvg from "Assets/Images/Survey/destination-icon.svg";
import useTraffic from "Hooks/useTraffic";
import { Card, Stack, Typography } from "@mui/material";

const ICON_SIZE = 22;

const destinationIcon = icon({ iconUrl: destinationSvg, iconSize: [ICON_SIZE, ICON_SIZE] });
const sourceIconIcon = icon({ iconUrl: SourceSvg, iconSize: [ICON_SIZE, ICON_SIZE] });

export default function TrafficMarkerCluster() {
  const { zone } = useAppSelector((state) => state.zones);
  const { visible } = useAppSelector((state) => state.traffic);
  const { survayLayer } = useAppSelector((state) => state.layers);

  const { data } = useTraffic();
  const [radius, setRadius] = useState<number>(50);

  const handleSourcesMarker = (traffics: any) => {
    return traffics?.map((item: any, indx: number) => {
      if (!item.TTO_Data) return;
      const traffic = JSON.parse(`{${item.TTO_Data}}`);

      const tooltipContent = (
        <Tooltip direction="top" offset={[0, -20]}>
          <Card sx={{ py: 2, px: 3 }}>
            <Stack alignItems="center">
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography> {traffic.DeviceName} </Typography>
                <Typography> : نام سامانه </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                {" "}
                <Typography> {traffic.TTO}</Typography>
                <Typography> : تعداد</Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic.MethodName}</Typography>
                <Typography> : نوع سامانه</Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{traffic?.DeviceCode}</Typography>
                <Typography> : کد سامانه</Typography>
              </Stack>
            </Stack>
          </Card>
        </Tooltip>
      );
      return (
        <Marker position={[traffic.GeographicalAccident, traffic.GeographicalLength]} icon={sourceIconIcon}>
          {tooltipContent}
        </Marker>
      );
    });
  };

  const handleSetSourceClass = (n: number) => {
    if (n < 50) {
      return "marker-cluster marker-cluster-small source-s";
    }
    if (n >= 50 && n < 100) {
      return "marker-cluster marker-cluster-medium source-m";
    }
    return "marker-cluster marker-cluster-large source-l";
  };

  const createSourceCustomIcon = useCallback(function (cluster: MarkerCluster) {
    return L.divIcon({
      html: `<div><span>${cluster.getChildCount()}</span></div>`,
      className: handleSetSourceClass(cluster.getChildCount()),
      iconSize: L.point(40, 40, true),
    });
  }, []);

  if (!visible) return <></>;
  return (
    <>
      {" "}
      <Pane name={`${Math.random()}show_survay_marker`} style={{ zIndex: survayLayer }} key={`${zone}${survayLayer}`}>
        <MarkerClusterGroup chunkedLoading maxClusterRadius={radius} iconCreateFunction={createSourceCustomIcon}>
          {handleSourcesMarker(data)}
        </MarkerClusterGroup>
      </Pane>
    </>
  );
}

// name={`${Math.random()}show_survay_marker`}
